import axios from "axios";
import { useEffect, useState } from "react";
import loadIcon from '../images/loader2.webp';
import Select from "react-select";
import { setSeconds } from "date-fns";
import excel from '../images/excelicon.png';
import { exportArrayToExcel } from "../common/mylib";
const PaymentLedger=()=>
{
    const [startDate,setStartDate]=useState("2025-01-01");
    const [endDate,setEndDate]=useState(new Date().toISOString().split("T")[0]);
    const [ledgerData,setLedgerData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [ledgertitle,setLedgerTitle]=useState("Client Wise Balance Ledger");
    const [progress,setProgress]=useState(false);
    const [sortorder,setSortOrder]=useState(1);
    const apiClient = axios.create({
                            baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization':'Bearer '+localStorage.getItem("token")
                            }
                        });
    async function searchData(event)
    {
        if(event.target.id=="txtSearch" && event.target.value.trim().length>=1)
        {
            let arr=ledgerData.filter((e)=>e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0);
            setDataToDisplay(arr);
            return;
        }
        if(event.target.id=="txtSearch" && event.target.value.trim().length==0)
        {
            setDataToDisplay(ledgerData);
            return;
        }
        let start=startDate;
        let end=endDate;
        if(event.target.id=="dtStart")
        {
            setStartDate(event.target.value);
            start=event.target.value;
        }
        if(event.target.id=="dtEnd")
        {
            setEndDate(event.target.value);
            end=event.target.value;
        }
        setProgress(true);
        await apiClient.get("/api/Payment/GetPaymentLedger/"+start+"/"+end).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setLedgerData(reply.data.data);
                setDataToDisplay(reply.data.data.sort((e1,e2)=>e2.rentdue-e1.rentdue));
            }
        });
        setProgress(false);
    }
    function sortData(key)
    {
        let arr=[...ledgerData];
        if(key=="name" || key=="company")
        {
            arr.sort((e1,e2)=>e1[key]>e2[key]?1*sortorder:-1*sortorder);
        }
        else 
        {
            arr.sort((e1,e2)=>(parseFloat(e1[key])-parseFloat(e2[key]))*sortorder);
        }
        setDataToDisplay([...arr]);
        setSortOrder(sortorder*-1);
    }
    async function loadData()
    {
        setProgress(true);
        let d1=new Date();
        d1.setDate(1);
        let d2=new Date();
        let start=d1.toISOString().split("T")[0];
        let end=d2.toISOString().split("T")[0];        
        await apiClient.get("/api/Payment/GetPaymentLedger/"+start+"/"+end).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setLedgerData(reply.data.data);
                setDataToDisplay(reply.data.data.sort((e1,e2)=>e2.rentdue-e1.rentdue));
            }
        });
        setProgress(false);
    }
    useEffect(()=>{

        let d1=new Date();
        d1.setDate(1);
        setStartDate(d1.toISOString().split("T")[0]);
        loadData();        
    },[]);
    return(
        <>
            <div className="row">
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-5">
                    <input onChange={searchData} type="text" id="txtSearch" className="form-control form-control-sm" />
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-3">
                    <input onChange={searchData} type="date" id="dtStart" className="form-control form-control-sm" value={startDate} />
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-3">
                    <input onChange={searchData} type="date" id="dtEnd" className="form-control form-control-sm" value={endDate} />
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-1 text-end">
                    <img onClick={()=>{exportArrayToExcel(dataToDisplay,'PaymentLedger')}} alt="" src={excel} style={{width:'30px',cursor:'pointer'}} />
                </div>
            </div>
            <div style={{overflow:"auto",fontSize:'12px',marginTop:'10px'}}>
                <div className="fw-bold">{ledgertitle}</div>
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th><span onClick={()=>{sortData('name')}} style={{cursor:"pointer",textDecoration:"underline"}}>Name&#8597;</span></th>
                            <th><span onClick={()=>{sortData('company')}} style={{cursor:"pointer",textDecoration:"underline"}}>Company&#8597;</span></th>
                            {/*<th>Address</th>*/}
                            <th>Mobile</th>
                            <th><span onClick={()=>{sortData('rentdue')}} style={{cursor:"pointer",textDecoration:"underline"}}>Due&#8597;</span></th>
                            <th><span onClick={()=>{sortData('rentrcvd')}} style={{cursor:"pointer",textDecoration:"underline"}}>Received&#8597;</span></th>
                            <th><span onClick={()=>{sortData('tds')}} style={{cursor:"pointer",textDecoration:"underline"}}>TDS&#8597;</span></th>
                            <th><span onClick={()=>{sortData('discount')}} style={{cursor:"pointer",textDecoration:"underline"}}>Waive Off&#8597;</span></th>
                            <th><span onClick={()=>{sortData('balance')}} style={{cursor:"pointer",textDecoration:"underline"}}>Balance&#8597;</span></th>                            
                            <th><span onClick={()=>{sortData('securitybalance')}} style={{cursor:"pointer",textDecoration:"underline"}}>Security Balance&#8597;</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataToDisplay.map((e,i)=>
                            <tr key={i}>
                                <td>{i+1}</td>
                                <td>{e.name}</td>
                                <td>{e.company}</td>                                
                                {/*<td>{e.address +", "+e.city+"-"+e.state}</td>*/}
                                <td>{e.mobile}</td>
                                <td>{e.rentdue}</td>
                                <td>{e.rentrcvd}</td>
                                <td>{e.tds}</td>
                                <td>{e.discount}</td>
                                <td>{e.balance}</td>                                
                                <td>{e.securitybalance}</td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colSpan="4"></th>
                            <th >
                                {dataToDisplay.reduce((sum,item)=>sum+Number(item.rentdue),0)}<br/>
                            </th>
                            <th >
                                {dataToDisplay.reduce((sum,item)=>sum+Number(item.rentrcvd),0)}<br/>
                            </th>
                            <th >
                                {dataToDisplay.reduce((sum,item)=>sum+Number(item.tds),0)}<br/>
                            </th>
                            <th >
                                {dataToDisplay.reduce((sum,item)=>sum+Number(item.discount),0)}<br/>
                            </th>
                            <th >
                                {dataToDisplay.reduce((sum,item)=>sum+Number(item.balance),0)}<br/>
                            </th>                            
                            <th >
                                {dataToDisplay.reduce((sum,item)=>sum+Number(item.securitybalance),0)}<br/>
                            </th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>
                        </div>
                    </div>
                )}
        </>
    );
}
export default PaymentLedger;